export type ThemeId =
  | "clean"
  | "aurora"
  | "industrial"
  | "playful"
  | "clean-dark"
  | "ocean"
  | "sunset"
  | "forest"
  | "neon"
  | "paper";

export const THEME_IDS: readonly ThemeId[] = [
  "clean",
  "aurora",
  "industrial",
  "playful",
  "clean-dark",
  "ocean",
  "sunset",
  "forest",
  "neon",
  "paper",
];

export type TableMode = "compact" | "sticky" | "cards";
export const TABLE_MODES: readonly TableMode[] = ["compact", "sticky", "cards"];

export type Motion = "on" | "reduced";
export const MOTIONS: readonly Motion[] = ["on", "reduced"];

export const PREF_KEYS = {
  theme: "app.theme",
  tableMode: "app.tableMode",
  motion: "app.motion",
} as const;

/** Reads a per-browser preference; any failure or unknown value yields `fallback`. */
export function readPref<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  try {
    const v = localStorage.getItem(key);
    if (v === null) return fallback;
    return (allowed as readonly string[]).includes(v) ? (v as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writePref(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* private mode / blocked storage: ignore */
  }
}

if (import.meta.env.DEV) {
  try {
    console.assert(readPref("__x", THEME_IDS, "clean") === "clean");
    localStorage.setItem("__x", "dark");
    console.assert(readPref("__x", THEME_IDS, "clean") === "clean");
    localStorage.setItem("__x", "ocean");
    console.assert(readPref("__x", THEME_IDS, "clean") === "ocean");
    localStorage.removeItem("__x");
  } catch {
    /* storage unavailable */
  }
}
